import { render, staticRenderFns } from "./textContent.vue?vue&type=template&id=64bb58d3"
import script from "./textContent.vue?vue&type=script&lang=js"
export * from "./textContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports